import ShoppingCart from './shopping-cart';

const $ = window.jQuery;

/**
 * Locations is a map component
 */
class OfferRequest {
  constructor(selectors, shoppingCart) {
    this.selectors = selectors;
    this.shoppingCart = shoppingCart;

    this.offerRequestForm = $(selectors.offerRequestForm);

    this.shoppingCartContainer = $(selectors.shoppingCartContainer);
    this.productsContainer = $(selectors.productsContainer);
    this.addMoreProducts = $(selectors.addMoreProducts);

    this.form = $(selectors.form);
    this.hiddenProductsField = this.form.find('input[type="hidden"][value="{{gp-groot-offer-request-products}}"]');
  }

  init() {
    this.initializeCartContents();
    this.initializeClickHandlers();
  }

  initializeCartContents() {
    const productsJson = this.shoppingCart.getProductsAsJson();
    this.includeMarkupForProductsInShoppingCart(productsJson);
  }

  initializeClickHandlers() {
    this.productsContainer.on('change', 'input.quantity', (e) => {
      const control = $(e.currentTarget);
      const productNode = control.parentsUntil('.product').parent();
      const index = productNode.index();

      const newQuantity = this.shoppingCart.updateQuantity(index, control.val());

      if (newQuantity === 0) {
        this.shoppingCart.removeProductAtIndex(index);
        productNode.remove();
      }
      this.saveShoppingCartProductsToHiddenField();
    });

    this.productsContainer.on('change', 'select.volume', (e) => {
      const control = $(e.currentTarget);
      const productNode = control.parentsUntil('.product').parent();
      const imageNode = productNode.find('.image-container img');

      const index = productNode.index();
      const imageUrl = control.find('option:selected').data('image-src');

      imageNode.fadeOut(50, () => {
        imageNode.attr('src', imageUrl);
        imageNode.fadeIn(250);
      });

      this.shoppingCart.updateVolume(index, control.val());
      this.saveShoppingCartProductsToHiddenField();
    });

    this.productsContainer.on('change', 'select.frequency', (e) => {
      const control = $(e.currentTarget);
      const productNode = control.parentsUntil('.product').parent();
      const index = productNode.index();

      this.shoppingCart.updateFrequency(index, control.val());
      this.saveShoppingCartProductsToHiddenField();
    });

    $(document).on('gform_confirmation_loaded', () => {
      const dataLayerProducts = [];
      const products = JSON.parse(this.shoppingCart.getProductsAsJson());

      this.shoppingCart.clear();
      this.shoppingCartContainer.hide();
      this.addMoreProducts.hide();

      products.forEach((product) => {
        dataLayerProducts.push({
          product: product.title,
          afvalstroom: product.wasteType,
          inhoud: product.volume,
          aantal: product.quantity,
        });
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'quotationRequest',
        status: 'Verzonden',
        producten: dataLayerProducts,
      });
    });

    $(document).on('gform_post_render', () => {
      OfferRequest.limitDatePickerToFutureDates('.offer-request-preferred-date-of-delivery', true);
    });
  }

  includeMarkupForProductsInShoppingCart(productsJson) {
    $.ajax('/wp-json/gpgroot-webshop/v1/get-products', {
      cache: false,
      data: productsJson,
      method: 'POST',
      error: () => {
        this.shoppingCartContainer.html(OfferRequest.createErrorAlert('Er is iets fout gegaan bij het ophalen van de producten in uw winkelwagen. Neem als dit probleem zich voor blijft doen contact met ons op. Onze excuses voor het ongemak.'));
      },
      success: (data) => {
        this.shoppingCartContainer.html(data);

        if (productsJson && productsJson.length > 2) {
          this.addMoreProducts.show();
        }
        
        this.saveShoppingCartProductsToHiddenField();
      },
    });
  }

  saveShoppingCartProductsToHiddenField() {
    const productsJson = this.shoppingCart.getProductsAsJson();
    this.hiddenProductsField.val(`gpgroot-products-json:${productsJson}`);
  }

  static createErrorAlert(message) {
    const markup = `
      <div class="alert alert-danger">${message}</div>
    `;

    return markup;
  }

  static limitDatePickerToFutureDates(selector, refresh = false) {
    const node = $(`${selector} .datepicker`);
    const options = OfferRequest.getDutchOptions();
    options.minDate = '+2d';

    if (refresh) {
      node.datepicker('destroy');
    }
    
    node.datepicker(options);
    node.attr('autocomplete', 'off');
  }

  static getDutchOptions() {
    const dutchOptions = {
      closeText: 'Sluiten',
      prevText: 'Vorige',
      nextText: 'Volgende',
      currentText: 'Vandaag',
      monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
      monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
      dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
      dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
      dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
      weekHeader: 'Wk',
      dateFormat: 'dd-mm-yy',
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: '',
    };

    return dutchOptions;
  }
}

$(document).ready(() => {
  OfferRequest.limitDatePickerToFutureDates('.offer-request-preferred-date-of-delivery');

  const shoppingCart = new ShoppingCart();

  const offerRequest = new OfferRequest({
    offerRequestForm: '.offer-request-form',
    shoppingCartContainer: '.shopping-cart-contents',
    productsContainer: '.offer-request-form .products',
    addMoreProducts: '.add-more-products',
    form: '.offer-request-form form',
  }, shoppingCart);

  offerRequest.init();
});
